// extracted by mini-css-extract-plugin
module.exports = {"slot":"PromoSlotCard_slot__L30wJ","badge":"PromoSlotCard_badge__8DJ5I","title":"PromoSlotCard_title__3o1Wz","text":"PromoSlotCard_text__6Ta2H","cta":"PromoSlotCard_cta__64WGy"};